export default "__VITE_ASSET__CJGiCYU$__"